import countries from '../services/countries_states_cities.json'

export const ECU_PREFIXES = ["MP32_PLUS-", "MP48_PLUS-", "MP60_PLUS-"]
const COUNTRY_CODES = new Set(countries.map(country => country.iso3))

export function firmwareChoices(release, preRelease) {
  const choices = new Map()
  for (const [rows, channel] of [[release, "release"], [preRelease, "pre-release"]]) {
    if (!Array.isArray(rows)) throw new Error("Invalid firmware catalog")
    const seen = new Set()
    for (const row of rows) {
      if (!row || typeof row.name !== "string" || !/^[A-Za-z0-9_-]+$/.test(row.name) ||
          typeof row.md5 !== "string" || !/^[a-f0-9]{32}$/i.test(row.md5) ||
          !Number.isSafeInteger(row.length) || row.length <= 0 ||
          seen.has(row.name.toLowerCase())) {
        throw new Error("Invalid or duplicate firmware catalog entry")
      }
      seen.add(row.name.toLowerCase())
      const existing = choices.get(row.name)
      if (existing) {
        if (existing.md5.toLowerCase() !== row.md5.toLowerCase() || existing.length !== row.length) {
          throw new Error("Firmware contents differ between channels")
        }
        existing.channels.push(channel)
      } else {
        choices.set(row.name, { ...row, channels: [channel] })
      }
    }
  }
  return [...choices.values()].sort((a, b) => a.name.localeCompare(b.name))
}

export function validateAssignment(data, choices, resellers) {
  if (!ECU_PREFIXES.includes(data.ecu_prefix)) return "Select a supported ECU prefix"
  if (data.country_code !== "" && (!/^[A-Z]{3}$/.test(data.country_code) || !COUNTRY_CODES.has(data.country_code))) {
    return "Country must be ISO alpha-3 or empty"
  }
  if (!Number.isInteger(data.reseller_id) ||
      (data.reseller_id !== -1 && !resellers.some(row => row.id === data.reseller_id))) {
    return "Select a valid reseller"
  }
  if (data.reseller_id === -1 && data.country_code === "") return "Select a reseller or a country; global overrides are not allowed"
  if (!/^[A-Za-z0-9_-]+$/.test(data.fw_name) || data.fw_name.length > 100 ||
      !data.fw_name.startsWith(data.ecu_prefix)) return "Firmware name must match the ECU prefix and have no extension"
  if (!choices.some(row => row.name === data.fw_name)) return "Select a published firmware"
  if (Array.from(data.note).length > 255) return "Note must not exceed 255 characters"
  return ""
}

export function requestError(error, fallback) {
  return error?.response?.data?.message || error?.message || fallback
}
